'use client'
export { SafeAreaView } from 'react-native'
